import { Contract } from '@mobi/web-native-comms'
import { isReactNativeApp, subscribeToNative } from '@mobi/web-native-comms/web'
import { useEffect } from 'react'

export function useSubscribeToNative<K extends keyof Contract>(
  topic: K,
  fn: (data: Contract[K]) => void,
  deps: React.DependencyList = []
) {
  useEffect(() => {
    if (!isReactNativeApp) {
      return undefined
    }

    const { dispose } = subscribeToNative(topic, fn)
    return dispose
  }, deps)
}
